import * as React from 'react';
import { Route, RouteComponentProps, StaticContext, Switch } from 'react-router';
import EventsPerDay from 'src/components/Event/EventPerDay/EventsPerDay';
import EventDetail from 'src/pages/Event/EventDetail/EventDetail';
import HomePage from 'src/pages/Home/Home';
import HomeMobile from 'src/pages/Home/HomeMobile';
import LoginView from 'src/pages/Login/Login';
import EditEvent from 'src/pages/Management/EventManagement/EditEvent';
import { NotFound } from 'src/pages/NotFound/NotFound';
import SectionView from 'src/pages/SectionView/SectionView';
import { breakSmall } from 'src/variables';
import { ManageRoutes } from './manageRoutes';
import HideEvent from 'src/pages/Event/HideEvent/HideEvent';
import Impressum from 'src/components/layout/Header/Impressum'

const Routes: React.SFC = () => (
  <Switch>
    <Route
      exact={true}
      path="/"
      render={(props: RouteComponentProps<any, StaticContext, any>) => {
        window.scrollTo(0, 0);
        if (window.innerWidth <= breakSmall) {
          return <HomeMobile {...props} />;
        }
        return <HomePage {...props} />;
      }}
    />
    <Route exact={true} path="/impressum" component={Impressum} />
    <Route exact={true} path="/login" component={LoginView} />
    <Route path="/manage" component={ManageRoutes} />
    <Route
      exact={true}
      path="/section/:sectionTitle/:eventId"
      render={(props: RouteComponentProps<any, StaticContext, any>) => {
        window.scrollTo(0, 0);
        return <EventDetail {...props} />;
      }}
    />
    <Route exact={true} path="/section/:sectionTitle/:eventId/edit" component={EditEvent} />
    <Route exact={true} path="/section/:sectionTitle/:eventId/hide" component={HideEvent} />
    <Route
      path="/section/:sectionTitle"
      render={(props: RouteComponentProps<any, StaticContext, any>) => {
        if (window.innerWidth <= breakSmall) {
          return <EventsPerDay sectionTitle={props.match.params.sectionTitle} {...props} />;
        }
        return <SectionView {...props} />;
      }}
    />
    {/* 404 */}
    <Route component={NotFound} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.tsx